import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText, downloadFile } from "../../lib/api";
import { FileText, DownloadSimple } from "@phosphor-icons/react";

export default function CompanyDocuments() {
  const [docs, setDocs] = useState([]);

  useEffect(() => { api.get("/company-documents").then((r) => setDocs(r.data)); }, []);

  const grouped = docs.reduce((acc, d) => {
    (acc[d.category] = acc[d.category] || []).push(d);
    return acc;
  }, {});

  return (
    <div className="space-y-5" data-testid="employee-docs-page">
      <h1 className="font-heading text-2xl font-extrabold">Company documents</h1>
      {docs.length === 0 && (
        <div className="bg-white border border-stone-200 rounded-2xl p-10 text-center">
          <FileText size={40} className="mx-auto text-stone-300" />
          <p className="text-sm text-stone-400 mt-3">No company documents published yet.</p>
        </div>
      )}
      {Object.entries(grouped).map(([cat, items]) => (
        <div key={cat}>
          <h3 className="font-heading font-bold text-sm text-stone-500 uppercase tracking-wide mb-2">{cat}</h3>
          <div className="space-y-2">
            {items.map((d) => (
              <div key={d.id} className="bg-white border border-stone-200 rounded-2xl p-4 flex items-center justify-between gap-3" data-testid={`emp-company-doc-${d.id}`}>
                <div className="flex items-center gap-3 min-w-0">
                  <FileText size={22} weight="duotone" className="text-primary shrink-0" />
                  <div className="min-w-0">
                    <div className="font-semibold text-sm truncate">{d.title}</div>
                    <div className="text-xs text-stone-500">{d.department || "Company-wide"} · {(d.size / 1024).toFixed(1)} KB</div>
                  </div>
                </div>
                <button onClick={() => downloadFile(`/company-documents/${d.id}/download`, d.original_filename).catch((e) => toast.error(errText(e)))}
                  data-testid={`emp-download-doc-${d.id}`}
                  className="tap-scale w-10 h-10 flex items-center justify-center rounded-full bg-stone-100 text-primary shrink-0">
                  <DownloadSimple size={18} weight="bold" />
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
